import type { AnyAction, Reducer } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import { sharedReducers } from "./reducers/shared-reducers";
import { adminReducers } from "./reducers/admin-reducers";
import { studentReducers } from "./reducers/student-reducers";
import { teacherReducers } from "./reducers/teacher-reducers";
import { educationalAdvisorReducers } from "./reducers/educational-advisor-reducers";
import { providerReducers } from "./reducers/provider-reducers";
import { externalProviderReducers } from "./reducers/external-provider-reducers";
import { logoutUser } from "@user-management-context/write/application/use-cases/user-logout/logout-user";

// Wraps a reducer to reset its state on logout by passing undefined,
// which causes all sub-reducers to return their initialState.
// Although window.location.href destroys the store on logout,
// this ensures clean state for in-flight renders and test environments.
function withLogoutReset<S>(reducer: Reducer<S, AnyAction>): Reducer<S, AnyAction> {
  return (state: S | undefined, action: AnyAction) => {
    if (action.type === logoutUser.type) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}

const reducers = {
  shared: withLogoutReset(combineReducers(sharedReducers)),
  admin: withLogoutReset(combineReducers(adminReducers)),
  student: withLogoutReset(combineReducers(studentReducers)),
  teacher: withLogoutReset(combineReducers(teacherReducers)),
  educationalAdvisor: withLogoutReset(combineReducers(educationalAdvisorReducers)),
  provider: withLogoutReset(combineReducers(providerReducers)),
  externalProvider: withLogoutReset(combineReducers(externalProviderReducers)),
};

export default reducers;
